import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PostContent from "./postContent";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import ImageCarousel from "./imageCarrousel";
import "../../blog.css";
import { NextBlog } from "./nextBlog";

interface BlogPostProps {
  postsJson: PostContent[];
  fallback: string;
}

const BlogPost: React.FC<BlogPostProps> = ({ postsJson, fallback }) => {
  const { post: postHash } = useParams();
  const [content, setContent] = useState("");
  const [images, setImages] = useState<string[]>([]);
  const [metadataIndex, setMetadataIndex] = useState<number>(-1);
  const navigate = useNavigate();

  useEffect(() => {
    // TODO: If can't find, should throw not found
    const metadataIndex = postsJson.findIndex((v) => v.hash === postHash)!;
    if (metadataIndex === -1) navigate(`/${fallback}`, { replace: true });
    setMetadataIndex(metadataIndex);

    const metadata = postsJson.at(metadataIndex);
    const folder = metadata!.folder_name;
    const sourceImageOverride = metadata!.images;
    const imageCount = metadata!.image_amount;
    // Fetch the markdown
    fetch(`/resources/posts/${folder}/post.md`)
      .then((res) => res.text())
      .then(setContent);

    let possible: string[] = [];

    if (!sourceImageOverride) {
      possible = Array.from({ length: imageCount }, (_, i) => i + 1).map(
        (i) => `/resources/posts/${folder}/imgs/${i}.jpeg`
      );
    } else {
      possible = sourceImageOverride.map(
        (value) => `/resources/posts/${folder}/imgs/${value}`
      );
    }

    // Check which actually exist
    Promise.all(
      possible.map((url) => fetch(url).then((res) => (res.ok ? url : null)))
    ).then((urls) => setImages(urls.filter((u): u is string => !!u)));
  }, [fallback, navigate, postHash, postsJson]);

  const prev = metadataIndex > 0 ? postsJson.at(metadataIndex - 1) : undefined;
  const next =
    metadataIndex + 1 < postsJson.length
      ? postsJson.at(metadataIndex + 1)
      : undefined;
  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "0 auto",
        marginTop: "1rem",
        padding: "0 2rem",
        font: "system-ui, 'Helvetica', sans-serif",
        color: "#555",
      }}
      className="blog"
    >
      <article style={{ marginBottom: "3rem" }} className="post-content">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        <ImageCarousel images={images} />
      </article>
      <NextBlog
        prev={
          prev
            ? { route: `/${fallback}/${prev.hash}`, title: prev.title }
            : undefined
        }
        next={
          next
            ? { route: `/${fallback}/${next.hash}`, title: next.title }
            : undefined
        }
      />
    </div>
  );
};

export default BlogPost;
